import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Portfolio Contact from ${form.name}`);
    const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`);
    window.open(`mailto:ariyomtechsolutions@gmail.com?subject=${subject}&body=${body}`);
    setSent(true);
  };

  const contacts = [
    { icon: "email", label: "Email", value: "ariyomtechsolutions@gmail.com", href: "mailto:ariyomtechsolutions@gmail.com" },
    { icon: "instagram", label: "Instagram", value: "@ariyom_tech_solutions", href: "https://instagram.com/ariyom_tech_solutions" },
    { icon: "website", label: "Website", value: "ariyomtechsolutions.site", href: "https://ariyomtechsolutions.site" },
  ];

  const iconMap = {
    email: (
      <svg width="22" height="22" fill="none" stroke="var(--accent)" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/>
      </svg>
    ),
    instagram: (
      <svg width="22" height="22" fill="none" stroke="var(--accent)" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="var(--accent)" stroke="none"/>
      </svg>
    ),
    website: (
      <svg width="22" height="22" fill="none" stroke="var(--accent)" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20"/>
      </svg>
    ),
  };

  return (
    <div style={{ paddingTop: 100 }}>
      <div className="container" style={{ paddingBottom: 80 }}>
        <p style={{ color: "var(--accent)", fontWeight: 600, fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>
          Contact
        </p>
        <h1 className="section-title">Get In Touch</h1>
        <p className="section-sub">Have a project in mind? We would love to hear about it.</p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 40, maxWidth: 900 }}>
          <div className="card">
            {sent ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <p style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</p>
                <h3 style={{ fontWeight: 700, marginBottom: 8 }}>Message Sent!</h3>
                <p style={{ color: "var(--muted)", fontSize: 14 }}>
                  Your email client should have opened. We will get back to you soon.
                </p>
                <button
                  onClick={() => { setSent(false); setForm({ name: "", email: "", message: "" }); }}
                  className="btn btn-outline"
                  style={{ marginTop: 20 }}
                >
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <h3 style={{ fontWeight: 700, marginBottom: 8 }}>Send a Message</h3>
                <div>
                  <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Your Name</label>
                  <input name="name" value={form.name} onChange={handleChange} placeholder="John Doe" required />
                </div>
                <div>
                  <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Email Address</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="john@example.com" required />
                </div>
                <div>
                  <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Message</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project..."
                    rows={5}
                    required
                    style={{ resize: "vertical" }}
                  />
                </div>
                <button type="submit" className="btn btn-primary" style={{ padding: "12px", fontSize: 15, justifyContent: "center" }}>
                  Send Message
                </button>
              </form>
            )}
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <h3 style={{ fontWeight: 700, marginBottom: 4 }}>Contact Info</h3>
            {contacts.map((c) => (
              <a key={c.label} href={c.href} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <div className="card" style={{ display: "flex", gap: 16, alignItems: "center", padding: 18 }}>
                  {iconMap[c.icon]}
                  <div>
                    <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 2 }}>{c.label}</div>
                    <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text)" }}>{c.value}</div>
                  </div>
                </div>
              </a>
            ))}
            <div className="card" style={{ background: "rgba(0,229,255,0.05)", borderColor: "rgba(0,229,255,0.15)", marginTop: 8 }}>
              <p style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.7 }}>
                We typically respond within <strong style={{ color: "var(--text)" }}>24 hours</strong>. Looking forward to hearing about your project!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
